module.exports = new __parcel__URL__("step-chat-tools.459c0abf.svg").toString();